module.exports = {
      id: "cart-white-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#cart-white",
      toString: function () {
        return this.url;
      }
    }